import { modernFontOverlay } from "./modern-font-overlay";
import { futureFontOverlay } from "./future-font-overlay";
import { editorialFontOverlay } from "./editorial-font-overlay";
import type { FontSystemResult } from "../font-styles";
import { fontStyles } from "../font-styles";

export function getFontOverlay(overlayName: string | undefined): FontSystemResult {
    switch (overlayName) {
        case "modern":
            return modernFontOverlay.value;
        case "future":
            return futureFontOverlay.value;
        case "editorial":
            return editorialFontOverlay.value;
        default:
            return fontStyles;
    }
}
